exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user_coupon[data-v-7d249bec]{overflow-x:scroll;white-space:pre;width:230px;padding:5px 0;box-sizing:border-box;line-height:.8}.user_coupon>a[data-v-7d249bec]{display:block;padding:4px 10px;color:#212529;text-align:center;background-color:#dedede;border-radius:15px;margin-right:5px}.user_coupon>a[data-v-7d249bec]:last-child{padding-right:15px}", ""]);

// exports
